/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateRubricDto,
  CreateRubricVersionDto,
  ListRubricsParams,
  RubricDetailDto,
  RubricListItemDto,
  RubricVersionDetailDto
} from '../model';

import { customFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListRubricsUrl = (params: ListRubricsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/rubrics?${stringifiedParams}` : `/rubrics`
}

export const listRubrics = async (params: ListRubricsParams, options?: Parameters<typeof customFetch>[1]): Promise<RubricListItemDto[]> => {

  return customFetch<RubricListItemDto[]>(getListRubricsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRubricsQueryKey = (params?: ListRubricsParams,) => {
    return [
    `/rubrics`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRubricsQueryOptions = <TData = Awaited<ReturnType<typeof listRubrics>>, TError = unknown>(params: ListRubricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRubrics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRubricsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRubrics>>> = ({ signal }) => listRubrics(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRubrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRubricsQueryResult = NonNullable<Awaited<ReturnType<typeof listRubrics>>>
export type ListRubricsQueryError = unknown


export function useListRubrics<TData = Awaited<ReturnType<typeof listRubrics>>, TError = unknown>(
 params: ListRubricsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRubrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRubrics>>,
          TError,
          Awaited<ReturnType<typeof listRubrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRubrics<TData = Awaited<ReturnType<typeof listRubrics>>, TError = unknown>(
 params: ListRubricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRubrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRubrics>>,
          TError,
          Awaited<ReturnType<typeof listRubrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRubrics<TData = Awaited<ReturnType<typeof listRubrics>>, TError = unknown>(
 params: ListRubricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRubrics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListRubrics<TData = Awaited<ReturnType<typeof listRubrics>>, TError = unknown>(
 params: ListRubricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRubrics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRubricsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateRubricUrl = () => {




  return `/rubrics`
}

export const createRubric = async (createRubricDto: CreateRubricDto, options?: Parameters<typeof customFetch>[1]): Promise<RubricDetailDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<RubricDetailDto>(getCreateRubricUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createRubricDto)
  }
);}





export const getCreateRubricMutationKey = () => ['createRubric'] as const;

export const getCreateRubricMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRubric>>, TError,CreateRubricMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRubric>>, TError,CreateRubricMutationVariables, TContext> => {

const mutationKey = getCreateRubricMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRubric>>, CreateRubricMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createRubric(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRubricMutationResult = NonNullable<Awaited<ReturnType<typeof createRubric>>>
    export type CreateRubricMutationBody = CreateRubricDto
    export type CreateRubricMutationError = unknown
    export type CreateRubricMutationVariables = {data: CreateRubricDto}

    export const useCreateRubric = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRubric>>, TError,CreateRubricMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRubric>>,
        TError,
        CreateRubricMutationVariables,
        TContext
      > => {
      return useMutation(getCreateRubricMutationOptions(options), queryClient);
    }
    export const getGetRubricUrl = (id: string,) => {




  return `/rubrics/${id}`
}

export const getRubric = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<RubricDetailDto> => {

  return customFetch<RubricDetailDto>(getGetRubricUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRubricQueryKey = (id: string,) => {
    return [
    `/rubrics/${id}`
    ] as const;
    }


export const getGetRubricQueryOptions = <TData = Awaited<ReturnType<typeof getRubric>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRubric>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRubricQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRubric>>> = ({ signal }) => getRubric(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRubric>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRubricQueryResult = NonNullable<Awaited<ReturnType<typeof getRubric>>>
export type GetRubricQueryError = unknown


export function useGetRubric<TData = Awaited<ReturnType<typeof getRubric>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRubric>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRubric>>,
          TError,
          Awaited<ReturnType<typeof getRubric>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRubric<TData = Awaited<ReturnType<typeof getRubric>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRubric>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRubric>>,
          TError,
          Awaited<ReturnType<typeof getRubric>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRubric<TData = Awaited<ReturnType<typeof getRubric>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRubric>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRubric<TData = Awaited<ReturnType<typeof getRubric>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRubric>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRubricQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateRubricVersionUrl = (id: string,) => {




  return `/rubrics/${id}/versions`
}

export const createRubricVersion = async (id: string,
    createRubricVersionDto: CreateRubricVersionDto, options?: Parameters<typeof customFetch>[1]): Promise<RubricVersionDetailDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<RubricVersionDetailDto>(getCreateRubricVersionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createRubricVersionDto)
  }
);}





export const getCreateRubricVersionMutationKey = () => ['createRubricVersion'] as const;

export const getCreateRubricVersionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRubricVersion>>, TError,CreateRubricVersionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRubricVersion>>, TError,CreateRubricVersionMutationVariables, TContext> => {

const mutationKey = getCreateRubricVersionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRubricVersion>>, CreateRubricVersionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  createRubricVersion(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRubricVersionMutationResult = NonNullable<Awaited<ReturnType<typeof createRubricVersion>>>
    export type CreateRubricVersionMutationBody = CreateRubricVersionDto
    export type CreateRubricVersionMutationError = unknown
    export type CreateRubricVersionMutationVariables = {id: string;data: CreateRubricVersionDto}

    export const useCreateRubricVersion = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRubricVersion>>, TError,CreateRubricVersionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRubricVersion>>,
        TError,
        CreateRubricVersionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateRubricVersionMutationOptions(options), queryClient);
    }
    export const getArchiveRubricUrl = (id: string,) => {




  return `/rubrics/${id}/archive`
}

export const archiveRubric = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getArchiveRubricUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getArchiveRubricMutationKey = () => ['archiveRubric'] as const;

export const getArchiveRubricMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveRubric>>, TError,ArchiveRubricMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveRubric>>, TError,ArchiveRubricMutationVariables, TContext> => {

const mutationKey = getArchiveRubricMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveRubric>>, ArchiveRubricMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  archiveRubric(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveRubricMutationResult = NonNullable<Awaited<ReturnType<typeof archiveRubric>>>

    export type ArchiveRubricMutationError = unknown
    export type ArchiveRubricMutationVariables = {id: string}

    export const useArchiveRubric = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveRubric>>, TError,ArchiveRubricMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveRubric>>,
        TError,
        ArchiveRubricMutationVariables,
        TContext
      > => {
      return useMutation(getArchiveRubricMutationOptions(options), queryClient);
    }
    export const getUnarchiveRubricUrl = (id: string,) => {




  return `/rubrics/${id}/unarchive`
}

export const unarchiveRubric = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getUnarchiveRubricUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUnarchiveRubricMutationKey = () => ['unarchiveRubric'] as const;

export const getUnarchiveRubricMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveRubric>>, TError,UnarchiveRubricMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveRubric>>, TError,UnarchiveRubricMutationVariables, TContext> => {

const mutationKey = getUnarchiveRubricMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveRubric>>, UnarchiveRubricMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  unarchiveRubric(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveRubricMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveRubric>>>

    export type UnarchiveRubricMutationError = unknown
    export type UnarchiveRubricMutationVariables = {id: string}

    export const useUnarchiveRubric = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveRubric>>, TError,UnarchiveRubricMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unarchiveRubric>>,
        TError,
        UnarchiveRubricMutationVariables,
        TContext
      > => {
      return useMutation(getUnarchiveRubricMutationOptions(options), queryClient);
    }
